import { _isNil } from '@/littledash';

export const toFiniteNumberOrNull = (value: unknown): number | null => {
  if (_isNil(value)) {
    return null;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};
